export const clearArray = (array: any[]) => {
  while (array.length > 0) {
    array.pop();
  }
};